const DIGEST_DOMAIN = "origin.tenant-view.secret-override.sha256.v1";
const TEXT_ENCODER = new TextEncoder();

function canonicalJsonValue(value) {
    if (value === null || typeof value !== "object") return JSON.stringify(value);
    if (Array.isArray(value)) {
        return `[${value.map((entry) => canonicalJsonValue(entry)).join(",")}]`;
    }
    return `{${Object.keys(value).sort().map((key) =>
        `${JSON.stringify(key)}:${canonicalJsonValue(value[key])}`).join(",")}}`;
}

function base64(bytes) {
    let binary = "";
    for (const byte of bytes) binary += String.fromCharCode(byte);
    return btoa(binary);
}

export async function tenantViewSecretOverrideDigest(
    content,
    cryptoImpl = globalThis.crypto,
) {
    if (!cryptoImpl?.subtle?.digest) {
        throw new TypeError("SHA-256 is unavailable for secret-finding approval");
    }
    const canonical = canonicalJsonValue(content);
    const preimage = TEXT_ENCODER.encode(`${DIGEST_DOMAIN}\n${canonical}`);
    return base64(new Uint8Array(await cryptoImpl.subtle.digest("SHA-256", preimage)));
}
